import { BookIcon, CSVIcon, RepoIcon } from './icons';
import { resume } from './fileIndex';

export const EMAIL = 'aaronamelink@gmail.com';

export const SOCIAL_MEDIA_LINKS = {
    linkedin: 'https://www.linkedin.com/in/aaron-amelink-942380292/',
    email: 'mailto:'+EMAIL
};

export const TABS = [
    {
        name: 'Co-op Experience',
        link: '/overview/workexperience',
        icon: BookIcon
    },
    {
        name: 'Resume',
        link: resume.link,
        icon: CSVIcon
    },
    {
        name: 'Repositories',
        link: '/overview/repositories',
        icon: RepoIcon // Updated to use the Book icon
    }
];